import React from "react";
import { Product, Subcategory, Category } from "../../types/public.types";
import ProductGrid from "./ProductGrid";
import ServicesGrid from "./ServicesGrid";

interface SubcatProductsProps {
  products: Product[];
  filteredProducts: Product[];
  subcategory: Subcategory;
  category: Category;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

export default function SubcatProducts({
  products,
  filteredProducts,
  subcategory,
  category,
  searchQuery,
  setSearchQuery,
}: SubcatProductsProps) {
  if (category.slug === "agri-services") {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10">
        <ServicesGrid
          services={filteredProducts}
          title={`Services in ${subcategory.name}`}
          searchPlaceholder={`Search in ${subcategory.name}...`}
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
          hasServices={products.length > 0}
          emptyMessage="No listings here yet"
          emptySubMessage="There are no approved services registered under this subcategory."
          categorySlug={category.slug}
        />
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10">
      <ProductGrid
        products={filteredProducts}
        title={`Products in ${subcategory.name}`}
        searchPlaceholder={`Search in ${subcategory.name}...`}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        hasProducts={products.length > 0}
        emptyMessage="No listings here yet"
        emptySubMessage="There are no approved products registered under this subcategory."
        categorySlug={category.slug}
      />
    </div>
  );
}
